import classnames from 'classnames';
import { extendTailwindMerge } from 'tailwind-merge';

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'border-color': [
        'base-border',
        'base-border-b',
        'base-border-t',
        'base-border-r',
        'base-border-l',
      ],
    },
  },
});

export function cn(...inputs: any[]) {
  return twMerge(classnames(inputs));
}
